import React from "react";
import {
  PageList,
  ENUM_FORM_DISPLAY,
  ENUM_FORM_LAYOUT_CONTAINER,
} from "../../components/pageList";
import ActionCellRender from "../../components/actionCellRender";
import { IconTrash, IconPencil, IconSettings, IconCalculator } from "@tabler/icons";
import { TextInput, Select, Textarea } from "@mantine/core";
import PromotionRankEditor from "../../components/promotionRankEditor";
import PromotionTrackTester from "../../components/promotionTrackTester";

const apiEntity = "promotionTrack";

const tableSchema = {
  showActionColumn: true,
  columns: [
    { field: "code", headerName: "Code" },
    { field: "name", headerName: "Name" },
    { field: "cname", headerName: "Chinese Name" },
    {
      field: "ranks",
      headerName: "Ranks",
      cellRender: (col, row) => (row.ranks || []).length,
    },
    { field: "status", headerName: "Status" },
    {
      field: "action",
      cellRender: ActionCellRender,
      isAction: true,
      actions: [
        {
          name: "edit",
          icon: IconPencil,
          props: {},
        },
      ],
      actionMenu: [
        {
          name: "delete",
          label: "Delete data",
          icon: IconTrash,
          props: {
            color: "red",
          },
        },
      ],
    },
  ],
  searchableFields: ["code", "name", "cname"],
};

const formSchema = {
  title: "Promotion Track",
  display: {
    mode: ENUM_FORM_DISPLAY.LINK,
    size: "xl",
  },
  apiEntity,
  initialValues: {
    code: "",
    name: "",
    cname: "",
    status: "ACTIVE",
    ranks: [
      {
        rankNumber: 0,
        code: "",
        name: "",
        cname: "",
        overridingPlan: null,
        conditionLogic: "AND",
        conditions: [{ type: "POINT_BALANCE", pointType: null, minAmount: 0 }],
      },
      {
        rankNumber: 1,
        code: "",
        name: "",
        cname: "",
        overridingPlan: null,
        conditionLogic: "AND",
        conditions: [],
      },
    ],
    remark: "",
  },
  layout: {
    containers: [
      {
        key: "main-tabs",
        parent: null,
        type: ENUM_FORM_LAYOUT_CONTAINER.TABS,
        props: {
          variant: "default",
          defaultValue: "Setting",
        },
        tab: [
          {
            key: "tab-setting",
            label: "Setting",
            icon: IconSettings,
          },
          {
            key: "tab-tester",
            label: "Tester",
            icon: IconCalculator,
          },
        ],
      },
      {
        key: "basic-section",
        parent: "tab-setting",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Track",
          description:
            "A track is one career ladder. Consultants can belong to one track. Point-balance conditions pick their Point Type on each rank.",
        },
      },
      {
        key: "basic-g",
        parent: "basic-section",
        type: ENUM_FORM_LAYOUT_CONTAINER.GRID,
        props: {
          grow: true,
          gutter: 40,
        },
        cols: [
          { key: "basic-g1", props: { span: 6 } },
          { key: "basic-g2", props: { span: 6 } },
        ],
      },
      {
        key: "ranks-section",
        parent: "tab-setting",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Ranks",
          description:
            "Lowest rank first. Last rank is the top. Use AND if every condition must pass, OR if any one is enough.",
        },
      },
    ],
    fields: [
      {
        name: "code",
        parent: "basic-g1",
        component: TextInput,
        props: {
          required: true,
          label: "Code",
        },
      },
      {
        name: "name",
        parent: "basic-g1",
        component: TextInput,
        props: {
          required: true,
          label: "Name (Eng)",
        },
      },
      {
        name: "cname",
        parent: "basic-g1",
        component: TextInput,
        props: {
          label: "Name (Chi)",
        },
      },
      {
        name: "status",
        parent: "basic-g2",
        component: Select,
        props: {
          label: "Status",
          data: [
            { value: "ACTIVE", label: "ACTIVE" },
            { value: "INACTIVE", label: "INACTIVE" },
          ],
        },
      },
      {
        name: "remark",
        parent: "basic-g2",
        component: Textarea,
        props: {
          label: "Remark",
          minRows: 2,
        },
      },
      {
        name: "ranks",
        parent: "ranks-section",
        component: PromotionRankEditor,
        props: {},
      },
      {
        name: "promotionTrackTester",
        parent: "tab-tester",
        component: PromotionTrackTester,
        props: {},
      },
    ],
  },
};

const PromotionTrack = () => {
  return (
    <PageList
      title={"Promotion Tracks"}
      apiEntity={apiEntity}
      tableSchema={tableSchema}
      formSchema={formSchema}
      accessLinkEntity="pointType"
    />
  );
};

export default PromotionTrack;
